<template>
  <div v-if="visible" class="container mt-3">
    <div class="alert alert-info d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-2 mb-0">
      <div>
        <i class="bi bi-bell me-1"></i>
        Activa las notificaciones de Vida para enterarte al momento cuando te añadan un gasto compartido.
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-primary" :disabled="busy" @click="activar">Activar</button>
        <button class="btn btn-sm btn-outline-secondary" @click="cerrar">Ahora no</button>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger mt-2 mb-0">{{ error }}</div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import {
  obtenerEstadoPush,
  activarPush,
  bannerPushOculto,
  ocultarBannerPush
} from '../utils/pushNotifications';

export default {
  name: 'AvisoPush',
  setup() {
    const visible = ref(false);
    const busy = ref(false);
    const error = ref('');

    onMounted(async () => {
      if (bannerPushOculto()) return;
      try {
        const estado = await obtenerEstadoPush();
        visible.value = estado.supported && estado.enabled && estado.permission === 'default';
      } catch {
        visible.value = false;
      }
    });

    const activar = async () => {
      busy.value = true;
      error.value = '';
      try {
        await activarPush();
        ocultarBannerPush();
        visible.value = false;
      } catch (err) {
        error.value = err.response?.data?.error || err.message || 'No se pudieron activar las notificaciones';
      } finally {
        busy.value = false;
      }
    };

    const cerrar = () => {
      ocultarBannerPush();
      visible.value = false;
    };

    return { visible, busy, error, activar, cerrar };
  }
};
</script>
